<template>
  <div>
    <Header
      :history="history"
      :data="data"
      @goBack="goBack"
      @close="close"
    />

    <transition name="fade">
      <div v-if="isSuccess">
        <Tabs
          :data="drawerData"
          :drawerType="drawerType"
          :filters="filters"
          @change="change"
        />
      </div>
    </transition>

    <div
      v-if="isLoading"
      class="progress__wrapper text-xs-center py-5"
      :style="`height: ${contentHeight}px`"
    >
      <div class="progress">
        <v-progress-circular indeterminate color="accent" />
      </div>
    </div>
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { hasRole, calcContentHeight, isObject } from 'utils/functions'
import Header from './Header'
import Tabs from './Tabs'

export default {
  name: 'Financial',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    history: {
      type: Array,
      default: () => []
    },
    drawerType: {
      type: String,
      required: true
    },
    filters: {
      type: Object
    }
  },
  components: {
    Header,
    Tabs
  },
  computed: {
    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      currentStatus: null,
      drawerData: {},
      rides: [],
      contentHeight: 'none'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    isValidObject (val) {
      return isObject(val)
    },

    goBack () {
      this.$emit('goBack')
    },

    close () {
      this.$emit('close')
    },

    change (val) {
      this.$emit('change', val)
    },

    async loadData () {
      if (this.currentStatus === STATUS_IS_LOADING) return

      this.currentStatus = STATUS_IS_LOADING

      try {
        let invoiceData = {
          ...this.data,
          paymentStatus: 'CURRENT'
        }

        // closed invoice
        if (
          this.hasRole('billing', 'ROLE_GET_ORDER_SUMMARY') &&
          this.isValidObject(this.data) && this.data.id
        ) {
          const { data: res } = await this.$apiService.getRefundSummary(this.data.id)
          if (!res.valid) throw new Error()
          invoiceData = this.isValidObject(res.content)
            ? { ...res.content, ...this.data }
            : {}
        }

        this.$emit('updateHistory', {
          drawerType: 'financial',
          data: this.data
        })

        this.drawerData = invoiceData
        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR:', err)
        this.currentStatus = STATUS_FAILED
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.loadData()
      }
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
    this.loadData()
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.progress__wrapper {
  position: relative;
}

.progress {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%)
}

.content__title {
  color: $gray-7;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 800;
  padding: 22px 24px;
  text-align: center;
}
</style>
